<h2 matDialogTitle>
  {{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.TITLE' | translate }}

  <button
    mat-dialog-close
    mat-icon-button
    matSuffix
    data-testid="button-close-authorized-representative-dialog"
    type="button"
  >
    <mat-icon fontIcon="close" />
  </button>
</h2>

<mat-dialog-content>
  <p>{{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.INTRO' | translate }}</p>

  <div>
    <p>{{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.FOUND_AS_LABEL' | translate }}</p>
    <ol>
      <li>{{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.FOUND_AS_ITEM_1' | translate }}</li>
      <li>{{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.FOUND_AS_ITEM_2' | translate }}</li>
    </ol>
  </div>

  <p>{{ 'AUTHORIZED_REPRESENTATIVE_DIALOG.VERIFICATION_NOTE' | translate }}</p>

</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    [mat-dialog-close]="true"
    class="rs-btn--primary"
    data-testid="button-confirm-company-manager"
    type="button"
  >
    {{ 'CLOSE' | translate }}
  </button>
</mat-dialog-actions>